import {
  stripeIdSubscriptionFirstMonthly,
  stripeIdSubscriptionFirstYearly,
  stripeIdSubscriptionSecondMonthly,
  stripeIdSubscriptionSecondYearly,
  stripeIdSubscriptionThirdMonthly,
  stripeIdSubscriptionThirdYearly,
} from "@/constants/payment";
import { SubscriptionPlan, User } from "@/types/types";

export const getSubscriptionPlan = (
  stripeSubscriptionId: User["stripeSubscriptionId"] | null
): SubscriptionPlan => {
  if (
    stripeSubscriptionId === stripeIdSubscriptionFirstMonthly ||
    stripeSubscriptionId === stripeIdSubscriptionFirstYearly
  ) {
    return "first";
  } else if (
    stripeSubscriptionId === stripeIdSubscriptionSecondMonthly ||
    stripeSubscriptionId === stripeIdSubscriptionSecondYearly
  ) {
    return "second";
  } else if (
    stripeSubscriptionId === stripeIdSubscriptionThirdMonthly ||
    stripeSubscriptionId === stripeIdSubscriptionThirdYearly
  ) {
    return "third";
  }

  // Free plan
  return "free";
};
